module.exports = __webpack_public_path__ + "officialStatic/img/case44.04aa86f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case44.jpg
// module id = GaRK
// module chunks = 0